<template>
   <div>
    <neu-cards-slider-pricing class="section py-lg-5 py-0" :cards="cardProfessional" :iva="$t('iva-not-included')" :cards2="cardLawFirm" :title="$t('abogalitypro.subscriptions.title')">
      <template v-slot:conditions>
        <span>{{ $t('abogalitypro.subscriptions.law-firm-text') }}</span><br>
        <span> {{ $t('abogalitypro.subscriptions.price-text') }}</span>
      </template>
    </neu-cards-slider-pricing>
   </div>
</template>

<script>
/* import es from '@/lang/es/public/views/abogalitypro.json'
import en from '@/lang/en/public/views/abogalitypro.json' */
import NeuCardsSliderPricing from '@/components/base/ui/NeuCardsSliderPricing.vue'

export default {
  components: {
    NeuCardsSliderPricing
  },
/*   i18n: {
    messages: {
      es,
      en,
      mx: es
    }
  }, */
  data () {
    return {
      cardProfessional: [
        {
          title: this.$t('abogalitypro.subscriptions.professional-rate'),
          priceTitle: '9,90€',
          subtitle: this.$t('abogalitypro.subscriptions.try-free')
        }
      ],
      cardLawFirm: [
        {
          title: this.$t('abogalitypro.subscriptions.law-firm-rate'),
          priceTitle: '29€',
          subtitle: this.$t('abogalitypro.subscriptions.try-free')
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
/* @import '../../../../static-appopensalud/css/openlegal/colors.scss'; */

.orange {
  span  {
    color: $blue;
  }
}

@include mobile {
  /deep/ .neu-cards-slider .row [class*="col-"] {
    margin-left: 0 !important;
  }
}

/deep/ h3 {
  color: $blue !important;
}

/deep/ .card-ctn2 {
  @include mobile {
    padding: {
      left: 0rem !important;
      right: 0rem !important;
    }
    margin: {
      left: 0rem !important;
      right: 0rem !important;
    }
  }
  .neu-card {
    height: auto !important;
  }
}

/deep/ span {
  color: $blue;
  opacity: 0.8;
}
</style>


// WEBPACK FOOTER //
// src/components/views/abogalitypro/AbogalitySubscriptions.vue